/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IAccountLoyalty contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum layout {
    cardLayout = 'cardLayout',
    wideLayout = 'wideLayout',
    compact = 'compact'
}

export interface IAccountLoyaltyConfig extends Msdyn365.IModuleConfig {
    heading?: IHeadingData;
    className?: string;
    clientRender?: boolean;
    layout: layout;
    displayJoinDate?: boolean;
    displayAppleWallet?: boolean;
    displayGoogleWallet?: boolean;
    appleWalletBtnImage?: Msdyn365.IImageData;
    googleWalletBtnImage?: Msdyn365.IImageData;
    walletLoyaltyProgramName?: string;
    pointsExpirationReminder?: string;
    loyaltyTiersLink?: ILoyaltyTiersLinkData;
}

export interface IAccountLoyaltyResources {
    loyaltyCardLabel: string;
    joinDateFormatted: string;
    totalAvailablePointsLabel: string;
    expiringPointsFormatLabel: string;
    expiringPointsFormatAriaLabel: string;
    availablePointsLabel: string;
    availablePointsAriaLabel: string;
    loyaltyActivityDateLabel: string;
    loyaltyActivityBalanceLabel: string;
    redeemedPointsLabel: string;
    refundedPointsLabel: string;
    earnedPointsLabel: string;
    pendingPointsLabel: string;
    adjustedPointsLabel: string;
    backToShoppingText: string;
    loyaltyTierLabel: string;
    loyaltyCardLabel_CL: string;
    availablePointsLabel_CL_before: string;
    availablePointsLabel_CL_after: string;
}

export const enum HeadingTag {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    h5 = 'h5',
    h6 = 'h6'
}

export interface IHeadingData {
    text: string;
    tag?: HeadingTag;
}

export interface ILoyaltyTiersLinkData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
}

export interface IAccountLoyaltyProps<T> extends Msdyn365.IModule<T> {
    resources: IAccountLoyaltyResources;
    config: IAccountLoyaltyConfig;
}
